export interface Stepper {
  routerLink: string;
  icon: string;
  tabName: string;
  step?: ProductMenuEditionStep;
  published?: boolean;
  meanStep?: MeanMenuEditionSteps; // Only for means
  display?: boolean; // Display status for means (to remove in future)
  trueIndex?: number; // True index for means (to remove in future)
}

export enum ProductMenuEditionStep {
  CREATE = 'create',
  PARAMS = 'params',
  CONTENT = 'content',
  VALIDATION = 'validation',
  PUBLICATION = 'publication',
}

export enum MeanMenuEditionSteps {
  PARAMS = 'params',
  TARGETS = 'targets',
  CLASSIZ = 'classiz',
  SURVEYS = 'surveys',
  MAILS = 'mails',
  VALIDATION = 'validation',
}

// Calculated by getStepStatus() function
export enum ProductMenuStepStatus {
  DONE = 'done',
  UNDONE = 'undone',
}

export enum ProductMenuEditionStatus {
  PRISTINE = 'pristine', // User has never seen this step
  TOUCHED = 'touched', // User validated OR accessed 1 time the current step

  // Fields below are deprecated and shouldn't be used now.
  VALID = 'valid',
  ERRORED = 'error',
  UPDATED = 'updated',
}

// Last step of each products (validation or verification)
export enum ProductMenuValidationStep {
  CONDITIONS = 'conditions',
  SUMMARY = 'summary',
  TEST = 'test',
  PUBLISH = 'publish', // for coursiz
  SESSION = 'session', // for coursiz
}

/*Determine the value of the given editionInfo value, and permit to unlock or not the next step ;
 * If given value is already at TOUCHED, don't rewrite it ;
 * If form is valid, it's the GIVEN VALUE STATE who determine the final value ;
 * If form is invalid, the value stays at PRISTINE
 */
export function editionInfoValue(givenStatus: ProductMenuEditionStatus, isValid: boolean): ProductMenuEditionStatus {
  if (
    givenStatus === ProductMenuEditionStatus.TOUCHED ||
    (givenStatus === ProductMenuEditionStatus.PRISTINE && isValid)
  ) {
    return ProductMenuEditionStatus.TOUCHED;
  } else {
    return ProductMenuEditionStatus.PRISTINE;
  }
}

export function isStepDisabled(
  allStepStat: ProductMenuStepStatus | MeanMenuEditionSteps,
  step: ProductMenuEditionStep | MeanMenuEditionSteps,
  index: number,
  hasBeenPublished = false,
): boolean {
  // Each 1st step should be every time valid OR module has been published then every step is valid
  if (index === 0 || hasBeenPublished) {
    return false;
  }
  return allStepStat === ProductMenuStepStatus.UNDONE;
}

/**
 * Rules :
 * If [Current Step has been valid/accessed at least 1 time] OR [current step is already TOUCHED] OR [Product has been published]
 * Status Step is DONE
 * Else : Status Step is UNDONE
 * */
export function getStepStatus(
  previousStepStatus: ProductMenuStepStatus,
  editionStatus: ProductMenuEditionStatus,
  published?: boolean,
): ProductMenuStepStatus {
  if (
    published ||
    (previousStepStatus === ProductMenuStepStatus.DONE && editionStatus === ProductMenuEditionStatus.TOUCHED) ||
    editionStatus === ProductMenuEditionStatus.TOUCHED
  ) {
    return ProductMenuStepStatus.DONE;
  }
  return ProductMenuStepStatus.UNDONE;
}

// should be stepper - idéal Faire rattraper par le back ces valeurs
/**
 * Rules :
 *  Factory helping to transform editionInfo data from API
 * editionInfo values should be PRISTINE or TOUCHED
 * VALID and ERROR became TOUCHED, PRISTINE stays
 * Already published Products should be TOUCHED
 * */
export function menuEditionStatusFactory(editionStatus: ProductMenuEditionStatus): ProductMenuEditionStatus {
  if (editionStatus !== ProductMenuEditionStatus.PRISTINE && editionStatus !== ProductMenuEditionStatus.TOUCHED) {
    return ProductMenuEditionStatus.TOUCHED;
  }
  return editionStatus;
}
